import Module, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import UserDataManager from "../../../../manager/user_manager";
import LoaclStorage from "../../../../manager/local_storage";
import { RoadMap_tb_view } from "./roadmap_tb_view";
import EventManager from "../../../../manager/event_manager";

const {ccclass, property} = cc._decorator;

type callBack = (chipsNumb:number,autoBuy:Boolean)=>void;

@ccclass
@moduleInit("RoadMap_tb", true)
export  class RoadMap_tb extends Module<RoadMap_tb_view,null> {

    constructor(){
        super();
        // this.layer = ViewLayer.Mid;
        this.viewType = RoadMap_tb_view;
        this.windowPrefabResPath = 'package/yxx/module/roadmap_tb/roadMap_tb';
        // this.needAnim = true
        // this.needViewMask = true
        // this.clickAnywhereClose = false
    }

    onInit(arg){
        super.onInit(arg);
        this.bindEvent()

    }

    onShow(args){
        this.node.active = false
     }

    // protected onButtonClickName(name : string, customEventData){
    //     switch (name) {
    //         case 'narrowBtn':
    //             this.view.nodeRoots[0].node.active = false
    //             this.view.nodeRoots[1].node.active = true
    //             // this.view.nodeRoots[0].play("anim_roadmap_disable")
    //             this.view.nodeRoots[1].play("anim_roadmap_active")
    //             break;
    //         case 'enlargeBtn':
    //             this.view.nodeRoots[0].node.active = true
    //             this.view.nodeRoots[1].node.active = false
    //             // this.view.nodeRoots[1].play("anim_roadmap_disable")
    //             this.view.nodeRoots[0].play("anim_roadmap_active")
    //             break;
    //         default:
    //             break;
    //     }
    // }

    updateShow(intentData:any){
        if(!this.node.active) this.node.active = true
        // cc.log("~~~~updateShow~~~",intentData)
        this.view.updateShow(intentData)
    }

    private bindEvent() {
        this.eventBind("event_update_betresulthistory", this.updateShow);
        
    }

    onDestroy(){
        this.eventUnBind("event_update_betresulthistory", this.updateShow);
    }

}
